import { store } from '@src/state/store';
import { gameUpdated } from '@src/state/slices/slice_game';

import { Game } from '@src/lib/types';

export default () => (data: Game[]) => {
  data.map((game: Game) => store.dispatch(gameUpdated(game)));
};
